import { render, staticRenderFns } from "./processTaskObservationsUpdates.vue?vue&type=template&id=69e7649d&"
import script from "./processTaskObservationsUpdates.vue?vue&type=script&lang=js&"
export * from "./processTaskObservationsUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports